<div class="flex flex-column sm:flex-row sm:justify-content-between sm:align-items-center">
  <div class="flex">
    <app-assistant-profile-picture [image]="image" class="block mr-3"></app-assistant-profile-picture>
    <div class="mt-1">
      <div class="text-900 font-medium text-xl mb-2">
        {{name}}
        <span class="text-600">{{role}} </span>
        <i class="fal fa-info-circle text-600" pTooltip="Memory is disabled, so each entry is independent of the previous ones."></i>
      </div>
      <div class="flex align-items-center">
        <span class="text-600">{{description}}</span>
      </div>
    </div>
  </div>
</div>
